var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLivingF3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_479",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 57
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H56.49V56.49H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3911 0H1.08606C0.488741 0 0 0.488741 0 1.08635V55.3911C0 55.9884 0.488741 56.4771 1.08606 56.4771H33.2238C33.8211 56.4771 34.3316 55.9775 34.3099 55.3693V36.8407C34.299 35.4177 32.1486 35.4177 32.1377 36.8407V54.305H2.17212V37.9267H22.6886C23.286 37.9267 23.7747 37.438 23.7747 36.8407V26.653C23.7638 25.23 21.6135 25.23 21.6026 26.653V35.7437H2.17212V17.3343H22.6886C23.286 17.3343 23.7747 16.8455 23.7747 16.2482V2.17241H35.5263V9.68802C35.5263 10.2853 36.015 10.7741 36.6123 10.7741C37.2096 10.7741 37.6984 10.2853 37.6984 9.68802V2.17241H54.305V18.3335H36.6123C36.015 18.3335 35.5263 18.8223 35.5263 19.4196C35.5263 20.0169 36.015 20.5056 36.6123 20.5056H54.305V35.7546H42.7162C42.1188 35.7546 41.6301 36.2433 41.6301 36.8407C41.6301 37.438 42.1188 37.9267 42.7162 37.9267H54.305V54.305H44.5302C43.9326 54.305 43.4438 54.7937 43.4438 55.3911C43.4438 55.9884 43.9326 56.4771 44.5302 56.4771H55.3911C55.9884 56.4771 56.4771 55.9884 56.4771 55.3911V1.08635C56.4771 0.488741 55.9884 0 55.3911 0ZM21.6026 15.1621H2.17212V2.17241H21.6026V15.1621Z",
    fill: "#DF1995"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingF3);
export default __webpack_public_path__ + "static/media/living-f3.d58bdfca86c74df9b5bab1fe36762313.svg";
export { ForwardRef as ReactComponent };